import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SetupProfile from "@/components/Questionnaire";
import AdminPage from "@/components/AdminPage";

const GATEWAY_URL = "https://nombaseconnect.com";

// Unmatched routes are not a legitimate entry point — bounce to the Gateway.
function GatewayBounce() {
  useEffect(() => {
    window.location.replace(GATEWAY_URL);
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SetupProfile />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<GatewayBounce />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
